import { render } from "./Sell.vue?vue&type=template&id=896f5e0c&scoped=true"
import script from "./Sell.vue?vue&type=script&lang=js"
export * from "./Sell.vue?vue&type=script&lang=js"

import "./Sell.vue?vue&type=style&index=0&id=896f5e0c&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896f5e0c"]])

export default __exports__